import { render, staticRenderFns } from "./UpmsResource.vue?vue&type=template&id=02a1d1c4&"
import script from "./UpmsResource.vue?vue&type=script&lang=js&"
export * from "./UpmsResource.vue?vue&type=script&lang=js&"
import style0 from "./UpmsResource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports